import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useEventManagerContext } from "../../context/eventContext";

export default function AngebotSlot({ angebot, onReserve }) {
  /**
   * =========================================================
   * ✅ CONTEXT
   * =========================================================
   */
  const theme = useTheme();

  const { currentUser, isAStudent, isATeacher } = useAppContext();
  const { isAnEventManagerAdmin } = useEventManagerContext();

  /**
   * =========================================================
   * ✅ STATE / ROLE LOGIC
   * =========================================================
   */
  const isReserved = !!angebot.reservedBy;
  const isMine = angebot.reservedBy?.id === currentUser?.id;

  const isAllowedByRole =
    (angebot.type === "team" && isAStudent) ||
    (angebot.type === "leitung" && isATeacher);

  const isClickable =
    isAnEventManagerAdmin || ((!isReserved || isMine) && isAllowedByRole);

  /**
   * =========================================================
   * ✅ VISUAL STATE (color system)
   * =========================================================
   */

  const backgroundColor = isMine
    ? theme.palette.eventManager.slot.mine
    : isReserved
      ? theme.palette.eventManager.slot.reserved
      : theme.palette.eventManager.slot.free;

  const textColor = theme.palette.eventManager.textOnSlot;

  /**
   * =========================================================
   * ✅ RENDER
   * =========================================================
   */
  return (
    <Box
      onClick={() => isClickable && onReserve(angebot.id, angebot)}
      sx={{
        px: 1.6,
        py: 0.6,

        borderRadius: 999, // ✅ pill shape
        minWidth: "fit-content",

        backgroundColor,
        color: textColor,
        border: isMine ? `2px solid ${theme.palette.common.white}` : "none",
        filter: isMine ? "brightness(1.1)" : "none",

        fontSize: "0.75rem",

        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",

        cursor: isClickable ? "pointer" : "not-allowed",
        opacity: isClickable ? 1 : 0.5,

        transition: "all 0.2s ease",

        /**
         * ✅ HOVER EFFECT
         */
        "&:hover": isClickable
          ? {
              transform: "translateY(-1px)", // ✅ smoother than scale
              boxShadow: `0 2px 6px ${theme.palette.primary.main}`,
            }
          : {},
      }}
    >
      <Typography
        variant="caption"
        sx={{
          whiteSpace: "nowrap", // ✅ prevents line breaks inside chips
        }}
      >
        {angebot.reservedBy?.name || "frei"}
      </Typography>
    </Box>
  );
}
